import { useContext, useState } from 'react';
import StandardizedDataTable from '../../PrimeAids/StandardizedDataTable';
import { ReportContext } from '../../../context/ReportContext';
import { dataRollUp } from '../../PlotlyAids/dataRollUps';
import { formatDateToIsoExtDate, userColumns } from '../../../helpers';
import ReportLineChart from '../../PlotlyAids/ReportLineChart';
import ReportChartLayoutWrapper from '../../PlotlyAids/ReportChartLayoutWrapper';
import ExpandableInfoCard, {
    ExpandableInfoCardDescription,
    ExpandableInfoCardDetail,
} from '../../Cards/ExpandableInfoCard';

export const userMoneyPersonalityColumns = [
    { field: 'startDatetime', name: 'Start Date ({tz} time zone)', dataType: 'datetime' },
    { field: 'endDatetime', name: 'End Date ({tz} time zone)', dataType: 'datetime' },
    { field: 'outlook', name: 'Outlook', dataType: 'multiselect' },
    { field: 'influence', name: 'Influence', dataType: 'multiselect' },
    { field: 'focus', name: 'Focus', dataType: 'multiselect' },
    { field: 'emotions', name: 'Emotions', dataType: 'multiselect' },
    { field: 'bonus', name: 'Bonus', dataType: 'multiselect' },
];

const UserMoneyPersonality = () => {
    const { reportData, appliedTimeZone } = useContext(ReportContext);

    const columns = [...userColumns, ...userMoneyPersonalityColumns];

    const [filteredData, setFilteredData] = useState([]);

    // const rolledUp = dataRollUp(
    //     filteredData,
    //     (row) => formatDateToIsoExtDate(row.startDate),
    //     { count: true }
    // );

    // const chartData = [
    //     {
    //         name: 'Personality Reports Over Time',
    //         x: rolledUp.map((x) => x.groupByField),
    //         y: rolledUp.map((x) => x.count),
    //     },
    // ];

    return (
        <div className="space-y-6">
            <StandardizedDataTable
                data={reportData}
                columns={columns}
                onValueChange={setFilteredData}
            />
            {/* <ReportChartLayoutWrapper>
                <ReportLineChart
                    data={chartData}
                    chartTitle="Money Personality Reports Over Time"
                />
            </ReportChartLayoutWrapper> */}

            <ExpandableInfoCard title="What is this data?">
                <ExpandableInfoCardDescription>
                    This report shows Money Personality assessment results over time. Each
                    row represents a completed Money Personality assessment for a user,
                    capturing their financial traits and characteristics across five key
                    dimensions.
                </ExpandableInfoCardDescription>
                <ExpandableInfoCardDetail name={`Start Date (${appliedTimeZone} time zone)`}>
                    The date when the user began the Money Personality assessment.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name={`End Date (${appliedTimeZone} time zone)`}>
                    The date when the user completed the Money Personality assessment.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Outlook">
                    The user's viewpoint of money.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Influence">
                    How others impact the user's money decisions.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Focus">
                    Whether the user's focus is on the present or future.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Emotions">
                    How the user feels about money.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Bonus">
                    A noted personality trait of the user.
                </ExpandableInfoCardDetail>
            </ExpandableInfoCard>
        </div>
    );
};

export default UserMoneyPersonality;
